var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRotateRight = function SvgRotateRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 1920 1920",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.999 209.777h116.019L621.665 75.425 697.09 0l263.111 263.111-260.196 260.196-75.425-75.424 131.439-131.439h-116.02c-176.731 0-320 143.269-320 320H213.332c0-235.642 191.025-426.667 426.667-426.667Zm0 643.556c0-117.82 95.512-213.333 213.333-213.333h853.338c117.82 0 213.33 95.513 213.33 213.333v853.337c0 117.82-95.51 213.33-213.33 213.33H853.332c-117.821 0-213.333-95.51-213.333-213.33V853.333Zm213.333-106.666h853.338c58.91 0 106.66 47.756 106.66 106.666v853.337c0 58.91-47.75 106.66-106.66 106.66H853.332c-58.91 0-106.667-47.75-106.667-106.66V853.333c0-58.91 47.757-106.666 106.667-106.666Z"
  })));
};

export default SvgRotateRight;